import { i18n } from "@/plugins/i18n"

export default [
  {
    path: "episodes",
    component: () => import("@/views/Podcasts/Episodes/PodcastEpisodes.vue"),
    children: [
      {
        path: "",
        name: "station.podcasts.episodes",
        component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeList.vue"),
        meta: {
          pageTitle: i18n.t("episodes.list_title"),
          parent: "stations",
          rule: "owner",
        },
      },
      {
        path: "create",
        component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeAdd.vue"),
        name: "station.episodes.create",
        props: true,
        meta: {
          pageTitle: i18n.t("episodes.add_title"),
          parent: "stations",
          rule: "owner",
        },
      },
      {
        path: ":episodeKey",
        component: () => import("@/views/Podcasts/Episodes/PodcastEpisode.vue"),
        name: "station.podcasts.episode",
        props: true,
        meta: {
          pageTitle: "Episode",
          parent: "stations",
          rule: "owner",
        },
        children: [
          {
            name: "station.podcasts.episode.edit",
            path: "edit",
            props: true,
            component: () => import("@/views/Podcasts/Episodes/PodcastEpisodeEdit.vue"),
            meta: {
              pageTitle: i18n.t("episodes.settings_title"),
              parent: "stations",
              rule: "owner",
            },
          },
        ],
      },
    ],
  },
]
